import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {MatDatepickerIntl} from '@angular/material/datepicker';

@Injectable({providedIn: 'root'})
export class CdkMatDatepickerIntl extends MatDatepickerIntl {
    changes = new Subject<void>();
    calendarLabel = 'Calendário';
    closeCalendarLabel = 'Fechar calendário';
    comparisonDateLabel = 'Comparar datas';
    nextMonthLabel = 'Próximo mês';
    nextMultiYearLabel = 'Próximos 24 anos';
    nextYearLabel = 'Próximo ano';
    openCalendarLabel = 'Abrir calendário';
    prevMonthLabel = 'Mês anterior';
    prevMultiYearLabel = '24 anos anteriores';
    prevYearLabel = 'Ano anterior';
    switchToMonthViewLabel = 'Escolher data';
    switchToMultiYearViewLabel = 'Escolher mês e ano';
}
